import React from 'react';
import { TableBody, TableRow, TableCell, Typography, Box } from '@mui/material';
import { HiOutlineExclamationCircle } from 'react-icons/hi';

import DateTimeText from '../DateTimeText';
import TableSkeletons from '../../protected/associatedApplicants/tableSkeletons/TableSkeletons';
import RenderIf from '../../renderIf';
import MUICheckbox from '../checkbox';
import { Status, Link } from './components';

const formatter = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

const translateCurrency = (val) => {
    return formatter.format(val || 0);
};

const DashboardBody = ({
    list,
    disabled = false,
    selectedRows = [],
    headers,
    isFetching,
    handleNav,
    handleCheckbox = (event) => console.log('Body checkbox clicked', event),
}) => {
    return (
        <TableBody>
            <RenderIf isTrue={list.length > 0}>
                {list.map((item, i) => (
                    <TableRow
                        key={`row-${i}`}
                        style={{ backgroundColor: i % 2 === 1 ? '#F9FBFF' : null }}
                    >
                        {headers?.map((header, j) => {
                            // #TODO TechDebt - Create a Table structure in the database similar to Question structure wher Table Cell Type can be defined.
                            switch (header.type) {
                                case 'link':
                                    return (
                                        <TableCell key={`cell-${i}-${j}`}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    gap: (theme) => theme.spacing(0.5),
                                                }}
                                            >
                                                <RenderIf isTrue={header.id === 'LastName' && item.ForReview}>
                                                    <HiOutlineExclamationCircle
                                                        color={'#FA6400'}
                                                        style={{ fontWeight: 500 }}
                                                    />
                                                </RenderIf>
                                                <Link
                                                    label={item[header.id]}
                                                    href={item.href}
                                                    handleNav={handleNav}
                                                    disabled={isFetching || disabled}
                                                />
                                            </Box>
                                        </TableCell>
                                    );
                                case 'link-button':
                                    return (
                                        <TableCell key={`cell-${i}-${j}`}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    gap: (theme) => theme.spacing(0.5),
                                                }}
                                            >
                                                <RenderIf isTrue={header.id === 'LastName' && item.ForReview}>
                                                    <HiOutlineExclamationCircle
                                                        color={'#FA6400'}
                                                        style={{ fontWeight: 500 }}
                                                    />
                                                </RenderIf>
                                                <Link
                                                    label={item[header.id]}
                                                    href={item}
                                                    handleNav={handleNav}
                                                    disabled={isFetching || disabled}
                                                />
                                            </Box>
                                        </TableCell>
                                    );
                                case 'date':
                                    return (
                                        <TableCell key={`cell-${i}-${j}`}>
                                            <RenderIf isTrue={item[header.id] !== null}>
                                                <Typography
                                                    sx={{ fontSize: '13px', color: 'grey.field-text' }}
                                                    component="div"
                                                >
                                                    <DateTimeText
                                                        type="short"
                                                        date={item[header.id]}
                                                    />
                                                </Typography>
                                            </RenderIf>
                                        </TableCell>
                                    );
                                case 'status':
                                    return (
                                        <TableCell key={`cell-${i}-${j}`}>
                                            <Box>
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        backgroundColor: item[header.id].hex,
                                                        display: 'inline-block',
                                                        height: '0.5rem',
                                                        width: '0.5rem',
                                                        borderRadius: '50%',
                                                        border: `1px solid ${item[header.id].hex}`,
                                                    }}
                                                />
                                                &nbsp;
                                                {item[header.id].label}
                                            </Box>
                                        </TableCell>
                                    );
                                case 'invoice-status':
                                    let _status = item[header.id];

                                    return (
                                        <TableCell key={`cell-${i}-${j}`}>
                                            <Box>
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        backgroundColor: _status.hex,
                                                        display: 'inline-block',
                                                        height: '0.5rem',
                                                        width: '0.5rem',
                                                        borderRadius: '50%',
                                                        border: `1px solid ${_status.hex}`,
                                                    }}
                                                />
                                                &nbsp;
                                                {_status.label}
                                                {_status?.actionLabel ? ' / ' : null}
                                                {_status?.actionLabel ? (
                                                    <Link
                                                        label={_status.actionLabel}
                                                        href={item?.href}
                                                        handleNav={() => handleNav(item)}
                                                        disabled={isFetching}
                                                    />
                                                ) : null}
                                            </Box>
                                        </TableCell>
                                    );
                                case 'status-plaintext':
                                case 'invoice-status-plaintext':
                                    return <TableCell key={`cell-${i}-${j}`}>{item[header.id]?.label || item[header.id]?.description || ''}</TableCell>;
                                case 'StatusId':
                                    return (
                                        <TableCell key={`cell-${i}-${j}`}>
                                            <RenderIf isTrue={item[header.id] !== null}>
                                                <Status
                                                    statusId={item[header.id]}
                                                    displayLastUpdated={false}
                                                    styleOverride={{ fontSize: '13px' }}
                                                />
                                            </RenderIf>
                                        </TableCell>
                                    );
                                case 'review':
                                    return (
                                        <TableCell key={`cell-${i}-${j}`}>
                                            <RenderIf isTrue={item[header.id]}>
                                                <HiOutlineExclamationCircle
                                                    color={'#FA6400'}
                                                    style={{ fontWeight: 500 }}
                                                />
                                            </RenderIf>
                                        </TableCell>
                                    );
                                case 'currency':
                                    return (
                                        <TableCell key={`cell-${i}-${j}`}>
                                            <Typography sx={{ fontSize: '13px', color: 'grey.field-text' }}>
                                                {translateCurrency(item[header.id])}
                                            </Typography>
                                        </TableCell>
                                    );
                                case 'checkbox':
                                    return (
                                        <TableCell key={`cell-${i}-${j}`}>
                                            <MUICheckbox
                                                checked={selectedRows.includes(item)}
                                                onChange={(event) => handleCheckbox(event, item)}
                                            />
                                        </TableCell>
                                    );
                                default:
                                    return (
                                        <TableCell key={`cell-${i}-${j}`}>
                                            <Typography sx={{ fontSize: '13px', color: 'grey.field-text' }}>{item[header.id]}</Typography>
                                        </TableCell>
                                    );
                            }
                        })}
                    </TableRow>
                ))}
            </RenderIf>

            <RenderIf isTrue={!isFetching && list.length === 0}>
                <TableRow>
                    <TableCell
                        align="center"
                        colSpan={headers.length}
                    >
                        No records to show.
                    </TableCell>
                </TableRow>
            </RenderIf>

            <RenderIf isTrue={isFetching}>
                <TableSkeletons headerLength={Object.entries(headers).length} />
            </RenderIf>
        </TableBody>
    );
};

export default DashboardBody;
